document.addEventListener("DOMContentLoaded", function () {
  const customerDisplaysCarousel = new Swiper(".customer-displays__swiper", {
    slidesPerView: 2,
    freeMode: true,
    allowTouchMove: false,
    speed: 1600,
    watchSlidesProgress: true,
    centerInsufficientSlides: true,
    autoplay: {
      delay: 0,
      disableOnInteraction: false,
    },
    loop: true,
    breakpoints: {
      1400: {
        slidesPerView: 8,
      },
      900: {
        slidesPerView: 6,
      },
      700: {
        slidesPerView: 4,
      }
    },
  });
});